import { Box, Card, Container, Flex, styled } from '@grupoboticario/flora-react';

export const styles = {
  CurrentRankingCard: styled(Card, {
    backgroundColor: '$light-dark-1',
    padding: '$4',
    width: '100%',

    '&::before': {
      boxShadow: 'initial',
    },
  }),

  InfoCard: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    padding: '$4',
    width: '100%',

    '&::before': {
      boxShadow: 'initial',
    },
  }),

  InfoIcon: styled(Box, {
    marginTop: '$1',
  }),

  RankingWrapper: styled(Container, {
    display: 'grid',
    gap: '$4',
    padding: '$10 0',

    '@tablet': {
      gridTemplateColumns: '40% 1fr',
    },
  }),

  TierCard: styled(Card, {
    background: '$backgroundSecondary',
    padding: '$4',

    '&::before': {
      boxShadow: 'initial',
    },
  }),

  PositionsRankingCard: styled(Flex, {
    padding: '$5 $6',
    width: '100%',
    justifyContent: 'space-between',

    '&[data-title]': {
      padding: '$6',
      backgroundColor: '$backgroundSecondary',
    },
  }),

  PositionsRankingWrapper: styled(Flex, {
    flexDirection: 'column',
  }),

  PositionsList: styled(Flex, {
    flexDirection: 'column',
    maxHeight: '400px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '$1',
      paddingLeft: '$3',
    },

    '&::-webkit-scrollbar-thumb': {
      background: '$actionNavigationStandardStatic',
      borderRadius: '$small',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '$actionNavigationStandardDisabled',
      borderRadius: '$small',
    },

    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '$actionNavigationStandardHighlight',
    },
  }),

  RankPosition: styled(Flex, {
    padding: '$2',
    width: '100%',
    justifyContent: 'center',
    backgroundColor: '$nonInteractiveEmphasis',
  }),

  TotalCard: styled(Card, {
    padding: '$4',

    '&::before': {
      borderRadius: '$sharp',
    },
  }),

  Wrapper: styled(Flex, {
    gap: '$4',
    padding: '$10 0',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',

    '> ::before, * ::before': {
      boxShadow: 'initial',
    },
  }),
};

export default styles;
